module.exports = __webpack_public_path__ + "assets/img/33_92_big.52510dd1.jpg";